import { SagaIterator } from 'redux-saga';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import { IWorkbookDetailInfo } from '../../../../ts/models/IWorkbookInfo';
import { Workbooks } from '../../../../ts/resources/Workbooks';
import { DeleteContents, EditWorkbook, NewWorkbookForDatasource, SetContentPermissions, SetOwner, SetTabsWorkbook, SetTags } from '../../../actions/AppActionTypes';
import { ServiceLocator } from '../../../ServiceLocator';
import { deleteContents } from '../content/DeleteContentsSaga';
import { setContentPermissions } from '../content/SetContentPermissionsSaga';
import { handleSetTags } from '../SetTagsSagas';
import { handleEditWorkbookAction } from './EditWorkbookSaga';
import { handleNewWorkbookForDatasourceAction } from './NewWorkbookForDatasourceSagas';
import { handleSetOwner } from './SetOwnerSagas';
import { setTabsWorkbookSaga } from './SetTabsWorkbookSaga';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';

export function fetchWorkbookById(workbookId: string): ng.IPromise<IWorkbookDetailInfo> {
  const resource = ServiceLocator.get<Workbooks>('Workbooks');
  return resource.getById(workbookId);
}

export function getExtractDraftId(workbookId: string): ng.IPromise<IResult> {
  const resource = ServiceLocator.get<Workbooks>('Workbooks');
  return resource.getExtractDraftId(workbookId);
}


export function* rootWorkbookSaga(): SagaIterator {
  yield takeEvery(SetOwner, handleSetOwner);
  yield takeEvery(SetTabsWorkbook, setTabsWorkbookSaga);
  yield takeLatest(SetTags, handleSetTags);
  yield takeEvery(DeleteContents, deleteContents);
  yield takeLatest(SetContentPermissions, setContentPermissions);
  yield takeEvery(EditWorkbook, handleEditWorkbookAction);
  yield takeEvery(NewWorkbookForDatasource, handleNewWorkbookForDatasourceAction);
}
